import gsap from "gsap";

export default function pageLoading() {
  /***********************************************************************
   * 変数定義
   ***********************************************************************/
  const wrapper = document.querySelector('.loading_wrapper');
  const mask = document.querySelector('.loading_mask');
  const loadingText = document.querySelector('.loading-text');
  const loadingLogo = document.querySelector('.loading-logo');
  const linkEls = [
    ...document.querySelectorAll('a:not([href*="#"]):not([href*="tel:"]):not([target])'),
  ];
  const currentHostName = window.location.hostname;
  const leaveTime = 1.0; // ページ離脱時のアニメーション 単位：秒（よりスムーズに）
  const enterTime = 1.0; // ページ入場時のアニメーション 単位：秒（統一）

  // ローディングアニメーションのタイムライン
  const loadingTl = gsap.timeline();

  /***********************************************************************
   * ページ読み込み時のアニメーション
   ***********************************************************************/

  // 初期状態
  gsap.set(wrapper, { autoAlpha: 1 });

  // 「このタブで既に再生済みか？」
  const hasPlayed = sessionStorage.getItem('openingPlayed');

  /***********************************************************************
   * front-page の場合
   ***********************************************************************/
  if (loadingText && !hasPlayed) {

    // フラグ保存（このタブではもう再生しない）
    sessionStorage.setItem('openingPlayed', 'true');

    gsap.set(loadingText, { opacity: 0, y: 30 });
    gsap.set(loadingLogo, { opacity: 0, y: 30 });

    loadingTl
      // 1. テキストフェードイン
      .to(loadingText, {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: "power2.out"
      })

      // 2. テキスト表示待機
      .to({}, { duration: 1 })

      // 3. テキストフェードアウト + 背景色変更
      .to(loadingText, {
        opacity: 0,
        y: -30,
        duration: 0.5,
        ease: "power2.in"
      })
      .to(mask, {
        backgroundColor: "#404040", // ダークグレー（元のまま保持）
        duration: 0.8,
        ease: "power3.inOut"
      }, "<")

      // 4. ロゴフェードイン
      .to(loadingLogo, {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: "power2.out"
      })

      // 5. ロゴ表示待機
      .to({}, { duration: 1 })

      // 6. ロゴフェードアウト
      .to(loadingLogo, {
        opacity: 0,
        y: -30,
        duration: 0.5,
        ease: "power2.in"
      })

      // 7. マスクフェードアウト
      .to(mask, {
        autoAlpha: 0,
        duration: 0.8,
        ease: "power2.inOut"
      });

  } else {

    /***********************************************************************
     * 2回目以降 or 他ページ（シンプルフェードイン）
     ***********************************************************************/

    loadingTl
      // ステップ1: マスクを滑らかにフェードアウト
      .to(mask, {
        autoAlpha: 0,
        duration: enterTime * 0.6,
        ease: "power1.inOut"
      })
      // ステップ2: コンテンツを完全表示
      .to(wrapper, {
        autoAlpha: 1,
        duration: enterTime * 0.6,
        ease: "power1.out"
      }, "-=0.2"); // 少し重複させて自然に

  }

  /***********************************************************************
   * フォールバック（万一何か止まった場合）
   ***********************************************************************/
  const noScriptFallback = gsap.timeline({ paused: true });

  noScriptFallback.to(mask, {
    autoAlpha: 0,
    duration: 1,
    ease: "power2.inOut"
  });

  setTimeout(() => {
    if (mask && getComputedStyle(mask).visibility !== 'hidden') {
      noScriptFallback.play();
    }
  }, 10000);

  /***********************************************************************
   * ページ離脱時のアニメーション
   ***********************************************************************/
  const leaveTl = gsap.timeline({ paused: true });

  const loadingAnimation = (url) => {
    // 背景ぼかし効果を追加
    if (mask) {
      mask.classList.add('loading-active');
    }

    leaveTl
      .set(mask, {
        autoAlpha: 0,
        backgroundColor: "#F0F0F0" // 最初から#F0F0F0に設定
      })
      // ステップ1: 現在のコンテンツを緩やかにフェードアウト
      .to(wrapper, {
        opacity: 0.4,
        duration: leaveTime * 0.5,
        ease: "power1.out"
      })
      // ステップ2: #F0F0F0マスクを滑らかにフェードイン（濃くならない）
      .to(mask, {
        autoAlpha: 1,
        duration: leaveTime * 0.5,
        ease: "power1.inOut"
      }, "-=0.2"); // 重複させてスムーズに

    leaveTl.play();

    // ページ遷移処理
    setTimeout(() => {
      window.location = url;
    }, leaveTime * 850);
  };

  /***********************************************************************
   * リンク click 時の処理
   ***********************************************************************/
  linkEls.forEach((linkEl) => {
    linkEl.addEventListener(
      'click',
      (e) => {
        // command or control+クリックのときは処理しない
        if ((e.ctrlKey && !e.metaKey) || (!e.ctrlKey && e.metaKey)) return;

        const url = linkEl.getAttribute('href');
        if (!url) return;

        e.preventDefault(); // cancel navigate
        loadingAnimation(url);
      },
      false,
    );
  });

  // SafariでブラウザバックするとJSなどが解除されていない問題【bfcache】の対策
  // 強制リロード
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      // bfcache発動時の処理
      window.location.reload();
    }
  });
}
